import template from './announcement-preview.html';

const mapStateToThis = ({ announcements }) => {
  const { active } = announcements;

  return {
    active,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class AnnouncementPreviewController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class AnnouncementPreviewComponent {
  constructor() {
    this.controller = AnnouncementPreviewController;
    this.template = template;
    this.bindings = {
      close: '&',
      resolve: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/announcement-preview/announcement-preview-component.js